window.EASY ||= {};
window.EASY.fireworks = {
  /**
   * Start render firework in window
   * @param {HTMLElement} container - inner element which makes border for effect
   * */
  fire: async container => {
    const { Fireworks } = await import("fireworks-js");
    window.firework = new Fireworks(container, {
      hue: { min: 0, max: 360 },
      delay: { min: 20, max: 30 },
      speed: 4,
      acceleration: 1.05,
      friction: 0.98,
      gravity: 1,
      particles: 120,
      traceLength: 3,
      explosion: 10,
      boundaries: {
        x: 50,
        y: 50,
        width: container.clientWidth,
        height: container.clientHeight,
      },
      sound: {
        enabled: false,
        files: [],
        volume: { min: 4, max: 8 },
      },
    });
    window.firework.start();

    return window.firework;
  },
};
